module.exports = __webpack_public_path__ + "static/img/lang-arabic.9615d98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lang-arabic.svg
// module id = O8r0
// module chunks = 1